import { Component, ViewChild } from '@angular/core';
import { ReviewManager } from '@managers/review.manager';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { map, takeUntil } from 'rxjs';
import { BaseComponent } from '../../base.component';
import { Store } from '@ngrx/store';
import { currentDocumentView } from '@store/doc-viewer/document-view/document-view.selectors';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'lex-doc-viewer-information-bar',
    templateUrl: './doc-viewer-information-bar.component.html',
    styleUrls: ['./doc-viewer-information-bar.component.scss'],
    standalone: false
})
export class DocViewerInformationBarComponent extends BaseComponent {

  public reviewStatus: number;
  public currentDocIndex$ = this.docViewerStore.simpleState$.pipe(map((current) => current.currentDocIndex || 0));
  public totalDocs$ = this.docViewerStore.simpleState$.pipe(map((current) => current.totalDocs || 0));
  public mode: 'viewer' | 'review' = 'viewer';
  public documentView$ = this.store.select(currentDocumentView());
  public remainingReviewDocCount: number;
  public reviewedByMeCount: number;
  public hasProduction: boolean;
  public hasPdf: boolean;
  public pages: string[];
  public maxPage: number;
  public currentPage: number;
  public currentPageDisplayValue: string;
  public selectedProduction: [string, string];
  public productionDocs: [string, string][];
  public pageSelectMenuWidth: number;

  @ViewChild(CdkVirtualScrollViewport) cdkViewPort: CdkVirtualScrollViewport;

  constructor(
    public docViewerStore: DocViewerStore,
    private reviewManager: ReviewManager,
    private store: Store
  ) {
    super();
    this.docViewerStore.simpleState$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((current) => {
      this.hasPdf = current.hasPdfRendering;
      this.hasProduction = current.hasProduction;
      this.reviewStatus = current.reviewStatus;
      this.mode = current.mode;
      this.remainingReviewDocCount = current.remainingReviewDocCount;
      this.reviewedByMeCount = current.reviewedByMeCount;
      this.pages = current.pages;
      this.maxPage = current.maxPage;
      this.currentPage = current.currentPage;
      this.currentPageDisplayValue = this.currentPage && this.pages ? this.pages[this.currentPage - 1] : "";
      this.productionDocs = current.productionDocs;
      this.selectedProduction = current.productionDocs?.find(p => p[0] === current.productionId);
	});
  }

  public nextDoc() {
    this.reviewManager.goToNextDocument().subscribe();
  }

  public previousDoc() {
    this.reviewManager.goToPreviousDocument().subscribe();
  }

  public selectedProducedDocChanged(prod: [string, string]): void {
    this.selectedProduction = prod;
    this.docViewerStore.updateState((currentState) => {
			currentState.productionId = prod[0];
			return currentState;
		});
  }

  public goToPreviousPage(): void {
    this.reviewManager.goToPage(this.currentPage - 1);
  }

  public goToNextPage(): void {
    this.reviewManager.goToPage(this.currentPage + 1);
  }

  public goToPage(pageNumber: number): void {
    this.reviewManager.goToPage(pageNumber);
  }

  public pageMenuOpened(): void {
    this.cdkViewPort.checkViewportSize();
    setTimeout(() => {
      this.cdkViewPort.scrollToIndex(this.currentPage - 1);
    }, 10);
  }
}
